import '@mantine/core/styles.layer.css'
import '@mantine/notifications/styles.layer.css'
import '@mantine/spotlight/styles.layer.css'
import { registerSW } from 'virtual:pwa-register'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { useOfflineStore } from './hooks/use-offline-store'
import './index.css'

// Service worker enables offline shell + downloaded-track playback. Auto-updates;
// downloaded audio lives in IndexedDB and is unaffected by SW updates.
registerSW({ immediate: true })

// Load which tracks are already downloaded so the UI reflects offline state.
void useOfflineStore.getState().hydrate()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
